import React from 'react';
import { AlertCircle, TrendingUp, Star } from 'lucide-react';
interface StockAlertProps {
  href: string;
}
export function StockAlert({
  href
}: StockAlertProps) {
  return <div className="my-12 bg-gradient-to-br from-orange-50 to-yellow-50 border-2 border-orange-300 rounded-2xl p-8 shadow-2xl" data-id="element-71">
      {/* Alert Header */}
      <div className="flex items-center justify-center gap-3 mb-6" data-id="element-72">
        <div className="w-12 h-12 rounded-full bg-orange-500 flex items-center justify-center animate-pulse" data-id="element-73">
          <AlertCircle className="w-7 h-7 text-white" data-id="element-74" />
        </div>
        <div data-id="element-75">
          <h3 className="text-2xl font-serif font-bold text-gray-900" data-id="element-76">
            UPDATE: High Demand Due to Viral Social Media Attention
          </h3>
        </div>
      </div>

      {/* Stock Status Bar */}
      <div className="bg-white rounded-lg p-4 mb-6 border border-orange-200" data-id="element-77">
        <div className="flex items-center justify-between mb-2" data-id="element-78">
          <span className="text-sm font-bold text-gray-700" data-id="element-79">
            Current Stock Level:
          </span>
          <span className="text-sm font-bold text-orange-600" data-id="element-80">
            LOW INVENTORY
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden" data-id="element-81">
          <div className="bg-gradient-to-r from-orange-500 to-red-500 h-3 rounded-full animate-pulse" style={{
          width: '23%'
        }} data-id="element-82"></div>
        </div>
        <p className="text-xs text-gray-500 mt-2 flex items-center gap-1" data-id="element-83">
          <TrendingUp className="w-3 h-3" data-id="element-84" />
          <span data-id="element-85">Selling fast - 127 orders in the last 24 hours</span>
        </p>
      </div>

      {/* Body Text */}
      <p className="text-lg text-gray-700 text-center mb-6 leading-relaxed" data-id="element-86">
        Inventory is <strong className="text-orange-700" data-id="element-87">extremely low</strong>.
        Please check the official store for availability and today's{' '}
        <strong className="text-[#2d5016]" data-id="element-88">50% OFF discount</strong>.
      </p>

      {/* Star Rating */}
      <div className="flex items-center justify-center gap-2 mb-6" data-id="element-89">
        <div className="flex gap-1" data-id="element-90">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-91" />)}
        </div>
        <span className="text-2xl font-bold text-gray-900" data-id="element-92">4.9/5</span>
        <span className="text-gray-600" data-id="element-93">(2,847 reviews)</span>
      </div>

      {/* CTA Button */}
      <a href={href} target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-[#2d5016] to-[#1e3a0f] hover:from-[#1e3a0f] hover:to-[#0f1d08] text-white text-center font-bold text-xl py-6 px-8 rounded-xl shadow-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-3xl" data-id="element-94">
        <span className="flex items-center justify-center gap-3" data-id="element-95">
          <span data-id="element-96">CHECK AVAILABILITY & CLAIM DISCOUNT</span>
          <span className="text-2xl" data-id="element-97">→</span>
        </span>
      </a>

      {/* Trust Indicators */}
      <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-sm text-gray-600" data-id="element-98">
        <div className="flex items-center gap-1" data-id="element-99">
          <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-100"></div>
          <span data-id="element-101">Secure Checkout</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-102">
          <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-103"></div>
          <span data-id="element-104">30-Day Guarantee</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-105">
          <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-106"></div>
          <span data-id="element-107">Free Shipping</span>
        </div>
      </div>
    </div>;
}